export const NAV_STATES = {
    ANALYTICS: 'analytics',
    APP_STORE: 'app-store',
    CATEGORIES: 'categories',
    CUSTOMERS: 'customers',
    DASHBOARD: 'dashboard',
    EDIT_STORE: 'edit-store',
    MY_ACCOUNT: 'my-account',
    ORDERS: 'orders',
    PAGES: 'pages',
    PRODUCTS: 'products',
    SETTINGS: 'settings',
    SITE_DESIGNER: 'designer',
    VOLUSION_PAYMENTS: 'volusion-payments',
    EDIT_MENU: 'edit-menu',
    MENU_MANAGEMENT: 'menuManagement',
    SITE_TAGGING: 'siteTagging',
    USER_PERMISSIONS: 'users',
    BLOCK_MANAGEMENT: 'blocks',
    DISCOUNTS: 'discounts'
};



// WEBPACK FOOTER //
// ./src/app/components/navigationMenu/navigationMenu.constants.js